import React from "react";

const LecturesCard = ({ lecture }) => {
  return (
    <div class="block rounded-lg p-4 shadow-sm shadow-indigo-100 max-w-sm">
      <iframe
        className="rounded-lg"
        width="100%"
        height="200"
        src={lecture?.videoUrl}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
        allowfullscreen
      ></iframe>

      <div class="mt-2">
        <dl>
          <div>
            <dt class="sr-only">lectures name</dt>
            <dd class="text-sm text-gray-500">{lecture?.lecturersName}</dd>
          </div>

          <div>
            <dt class="sr-only">title</dt>
            <dd class="font-medium">{lecture?.videoTitle}</dd>
          </div>
        </dl>

        <div class="mt-6 flex items-center gap-8 text-sm">
          <p>{lecture?.videoDes}</p>
        </div>
      </div>
    </div>
  );
};

export default LecturesCard;
